import React from 'react';
import { LagoonFeatures } from 'src/common/LagoonUHC/LagoonFeatures';

export const CoreFeatures = ({ ...props }) => <LagoonFeatures {...props} />;
